<template>
  <div class="studentRequirementSubmissionCreate">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :exact="true"
        :to="{ name: 'studentRequirementSubmission', params: {} }"
      >
        Student Submissions
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        :to="{ name: 'studentRequirementSubmissionCreate', params: {} }"
      >
        New Submission
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>New Submission</v-card-title>
      <v-card-text>
        <studentRequirementSubmission-form :studentId="studentId" :requirements="requirements"></studentRequirementSubmission-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import StudentRequirementSubmissionForm from "./StudentRequirementSubmissionForm.vue";

export default {
  name: "studentRequirementSubmission",
  components: {
    StudentRequirementSubmissionForm
  },
  data: () => {
    return { 
      studentId: null,
      requirements: null
    }
  },
  created() {
    this.studentId = this.$route.query.studentId;
    this.requirements = this.$route.query.requirements;
    this.$emit("showParent", false);
  }
};
</script>
